import { defineStore } from 'pinia'

export const useModalStore = defineStore('modal', () => {
  // 下载弹窗状态
  const showDownloadModal = ref(false)

  // 打开下载弹窗
  const openDownloadModal = () => {
    showDownloadModal.value = true
  }

  // 关闭下载弹窗
  const closeDownloadModal = () => {
    showDownloadModal.value = false
  }

  // 个人设置弹窗状态
  const showPersonalSettingsModal = ref(false)

  // 打开个人设置弹窗
  const openPersonalSettingsModal = () => {
    showPersonalSettingsModal.value = true
  }

  // 关闭个人设置弹窗
  const closePersonalSettingsModal = () => {
    showPersonalSettingsModal.value = false
  }

  // 注销弹窗状态
  const showWriteOffModal = ref(false)

  // 打开注销弹窗
  const openWriteOffModal = () => {
    showWriteOffModal.value = true
  }

  // 关闭注销弹窗
  const closeWriteOffModal = () => {
    showWriteOffModal.value = false
  }

  const showMaterialUploadNoticeModal = ref(false)

  const openMaterialUploadNoticeModal = () => {
    showMaterialUploadNoticeModal.value = true
  }

  const closeMaterialUploadNoticeModal = () => {
    showMaterialUploadNoticeModal.value = false
  }

  // 订单记录（潮币值明细）弹窗
  const showInspirationValueModal = ref(false)
  const inspirationValueModalTab = ref<string | null>(null)

  const openInspirationValueModal = (tabType?: string) => {
    inspirationValueModalTab.value = tabType?.trim() || null
    showInspirationValueModal.value = true
  }

  const closeInspirationValueModal = () => {
    showInspirationValueModal.value = false
    inspirationValueModalTab.value = null
  }

  // 订阅管理弹窗
  const showSubscriptionManageModal = ref(false)

  const openSubscriptionManageModal = () => {
    showSubscriptionManageModal.value = true
  }

  const closeSubscriptionManageModal = () => {
    showSubscriptionManageModal.value = false
  }

  return {
    showDownloadModal,
    openDownloadModal,
    closeDownloadModal,
    showPersonalSettingsModal,
    openPersonalSettingsModal,
    closePersonalSettingsModal,
    showWriteOffModal,
    openWriteOffModal,
    closeWriteOffModal,
    showMaterialUploadNoticeModal,
    openMaterialUploadNoticeModal,
    closeMaterialUploadNoticeModal,
    showInspirationValueModal,
    inspirationValueModalTab,
    openInspirationValueModal,
    closeInspirationValueModal,
    showSubscriptionManageModal,
    openSubscriptionManageModal,
    closeSubscriptionManageModal,
  }
})
